import { Component } from '@angular/core';
import { LibTableComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-table',
  templateUrl: './app-table.component.html',
})

export class AppTableComponent extends LibTableComponent { }
